$ = require 'jquery'
PopOver = require 'views/lib/pop-over'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
trackUe = require 'debug/trackUe'

module.exports = class ChangeEmailFreqPopoverView extends View
  viewTitleKey: 'send emails'

  initialize: ->
    @listenTo @model, 'change:prefs', @frameDebounce @render

  events:
    'click li a': 'changeFreq'

  render: ->
    view = @
    data = @model.toJSON(prefs: true)

    @$el.html(
      templates.fill(
        'popover_set_email_freq',
        data
      )
    )

    @

  changeFreq: (e) ->
    value = parseInt($(e.target).closest('a').attr('value'))
    track(
      "Member",
      "Changed Email Frequency",
      @model.getPref('minutesBetweenSummaries'),
      value
    )
    if @options?.context == 'header'
      frequencyMap = {
        "-1": 'to never'
        "60": 'to periodically'
        "1": 'to instantly'
      }
      trackUe(
        'header',
        'changes',
        'email frequency',
        frequencyMap[value],
        'from notifications menu',
        'by clicking the allow desktop notifications button in notifications menu',
        ''
      )
    @model.setPref('minutesBetweenSummaries', value).save()
    PopOver.popView()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/change-email-freq-popover-view.coffee